// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordForm":"ForgotPasswordForm_forgotPasswordForm__3jFFH"};